
export const CheckOutFormStepHeading = (props: {
    children: React.ReactNode;
}) => {
    return (
        <h2 className="text-lg font-medium text-gray-900 mb-5 mt-2">
            {props.children}
        </h2>
    );
};